module.exports = __webpack_public_path__ + "img/11-3.bad92e31.png";